import { useParams, useNavigate,  } from 'react-router';
import { ArrowLeft, MapPin, DollarSign, Calendar, Shield, Building2, Clock, Image as ImageIcon, Video, Play, Trash, FileText, ArrowRight, CheckCircle2, CircleDot, Send } from 'lucide-react';
import { Lead } from '../components/LeadCardHomeOwner';
import { ContractorCard } from '../components/ContractorCard';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { CallAPIPostPromise } from 'Common/commaon';
import { getDecodeId } from 'slices/userProfile/thunk';
import { JobDetailsShimmer } from 'components/shimmer';
import { toProperCase } from 'Common/Hooks/UserHooks';
import { IoTrashOutline } from 'react-icons/io5';
import { TwoButtonAlert } from 'Common/twoButtonAlert';
import { LeadMessageModal } from 'pages/Projects/LeadMessageModal';
import './project-details.css';
import { InlineContractReview } from 'components/reviews/InlineContractReview';

interface LeadDetailsPageProps {
  leads: Lead[];
}

  

export function LeadDetailsPage() {
  const { id } = useParams();
 const [leads,setLeads]=useState([])
 const [alertDetails, setAlertDetails] = useState({
  status: false,
  title: "Warning!",
  message: "You’re about to delete your account forever, cutie 🥺",
  icon: IoTrashOutline,
  button1Text: "Keep it",
  button2Text: "Delete",
  button1Style:
    "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
  button2Style:
    "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition",
  onButton1Click: () => console.log("Saved 😌"),
  onButton2Click: () => console.log("Deleted 😭"),
});
  const [loading,setLoading]=useState(false)
  const navigate = useNavigate();
  const [chat, setChat] = useState<any>(false);

  const [selectedContractor, setSelectedContractor] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [selectedMedia, setSelectedMedia] = useState<number>(0);

  const lead = leads.find((l:any) => l.id === Number(id)) as any
  useEffect(()=>{
    document.title = "Project Details | RELiBUILD";
    setLoading(true)
    CallAPIPostPromise("/jobs/homeownerJobs",{
      homeowner_id:getDecodeId()
    }).then((res:any)=>{
    setLeads(res)
    }).finally(()=>{
      setLoading(false)
    })
      },[])
      if(loading){
        return <div className='page-content tailwind-prefix project-detail-page project-detail-page--loading px-2'>

<JobDetailsShimmer/>

        </div> 
      }
  if (!lead ) {
    return (
      <div className="project-detail-page project-detail-page--missing min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-2">Lead not found</h2>
          <p className="text-gray-600 mb-4">The lead you're looking for doesn't exist.</p>
          <button
            onClick={() => navigate('/pages-projects')}
            className="flex bg-[#181A20]  items-center border-0  text-white py-2 px-3 rounded-[7px]  mb-4"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Projects
          </button>
        </div>
      </div>
    );
  }

  const images = lead.media?.filter((m:any) => m.type === 'image') || [];
  const videos = lead.media?.filter((m:any) => m.type === 'video') || [];
  const allMedia = lead.media || [];
  const linkedContract = lead.linked_contract;
  const isLiveContract = linkedContract?.status === 'LIVE';
  const hasAcceptedContractor = Boolean(lead.accepted_contractor);
  const hasRequestedContractor = Number(lead.requested_contractors) > 0;
  const projectStage = isLiveContract ? 3 : hasAcceptedContractor ? 2 : 1;
  const projectStatusCopy = isLiveContract
    ? 'Your contract is active. Follow progress, review completed work, and stay in touch with your contractor.'
    : hasAcceptedContractor
      ? 'Your contractor has accepted the project and is preparing the agreement.'
      : hasRequestedContractor
        ? `Your request was sent to ${lead.requested_contractors} contractor${Number(lead.requested_contractors) === 1 ? '' : 's'}. We’ll let you know when one responds.`
        : 'Your project is open and available to qualified contractors.';

  return (
    <div className="page-content tailwind-prefix project-detail-page">
      {/* Header */}
      <Container>
      <div>
        <div className="project-detail__header py-4">
          <button
            onClick={() => navigate('/pages-projects')}
            className="project-detail__back flex items-center border-0 py-2 px-3 rounded-[7px] mb-4"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Projects
          </button>
          <div className="project-detail__hero">
            <div className="project-detail__hero-copy">
              <div className="project-detail__eyebrow">Home project · #{lead.id}</div>
              <h1>{lead.job_title}</h1>
              <p>{projectStatusCopy}</p>
            </div>
            <div className="project-detail__hero-status">
              <span className={`project-detail__status-pill project-detail__status-pill--${lead.job_status.toLowerCase()}`}>
                {lead.job_status === 'REQUESTED' ? 'Request sent' : lead.job_status === 'ACCEPTED' ? 'Contractor accepted' : lead.job_status === 'OPEN' ? 'Open project' : lead.job_status}
              </span>
              {isLiveContract && <button type="button" className="project-detail__hero-action" onClick={() => navigate(`/create-contract?tab=Project-Details&id=${linkedContract.id}`)}>Open contract <ArrowRight size={15} /></button>}
            </div>
          </div>
        </div>
      </div>

      <section className="project-detail__journey" aria-label="Project progress">
        <div className="project-detail__journey-heading">
          <div>
            <span>Project journey</span>
            <p>See what is complete and what happens next.</p>
          </div>
          <strong>{isLiveContract ? 'Contract live' : hasAcceptedContractor ? 'Agreement in progress' : 'Waiting for contractor'}</strong>
        </div>
        <div className="project-detail__journey-steps">
          <div className="project-detail__journey-step is-complete">
            <CheckCircle2 size={18} aria-hidden="true" />
            <div><strong>Project request</strong><span>{hasRequestedContractor ? 'Sent to selected contractors' : 'Published for contractors'}</span></div>
          </div>
          <div className={`project-detail__journey-step ${projectStage > 2 ? 'is-complete' : projectStage === 2 ? 'is-current' : ''}`}>
            {projectStage > 2 ? <CheckCircle2 size={18} aria-hidden="true" /> : <CircleDot size={18} aria-hidden="true" />}
            <div><strong>Contractor</strong><span>{hasAcceptedContractor ? `${lead.accepted_contractor?.user_first_name} accepted the project` : 'Waiting for a contractor to accept'}</span></div>
          </div>
          <div className={`project-detail__journey-step ${projectStage === 3 ? 'is-current is-complete' : ''}`}>
            {projectStage === 3 ? <CheckCircle2 size={18} aria-hidden="true" /> : <FileText size={18} aria-hidden="true" />}
            <div><strong>Agreement</strong><span>{isLiveContract ? 'Live and ready to track' : hasAcceptedContractor ? 'Your contractor will prepare it next' : 'Starts after acceptance'}</span></div>
          </div>
        </div>
      </section>

      {/* Content */}
      <div className="pb-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Column */}
          <div className="project-detail__main lg:col-span-2 space-y-6">
            {/* Media Gallery */}
            {allMedia.length > 0 && (
              <details className="project-detail__panel project-detail__media bg-white border border-gray-200 rounded-lg overflow-hidden">
                <summary className="project-detail__media-summary">
                  <span><ImageIcon size={17} aria-hidden="true" /> Project photos & videos <small>{allMedia.length} file{allMedia.length === 1 ? '' : 's'}</small></span>
                  <span className="project-detail__media-toggle">View media</span>
                </summary>
                <div className="relative bg-gray-900 aspect-video">
                  {allMedia[selectedMedia].type === 'image' ? (
                    <img
                      src={allMedia[selectedMedia].url}
                      alt={lead.job_title}
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <div className="relative w-full h-full">
                      <video
                        src={allMedia[selectedMedia].url}
                        controls
                        className="w-full h-full"
                      />
                    </div>
                  )}
                  <div className="absolute top-4 left-4 bg-black/70 text-white px-3 py-1 rounded text-sm">
                    {selectedMedia + 1} / {allMedia.length}
                  </div>
                </div>
                {allMedia.length > 1 && (
                  <div className="p-4 bg-gray-50">
                    <div className="flex gap-2 overflow-x-auto">
                      {allMedia.map((media:any, index:any) => (
                        <button
                          key={index}
                          onClick={() => setSelectedMedia(index)}
                          className={`relative flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                            selectedMedia === index ? 'border-blue-600' : 'border-gray-200 hover:border-gray-300'
                          }`}
                        >
                          <img
                            src={media.type === 'image' ? media.url : media.thumbnail}
                            alt=""
                            className="w-full h-full object-cover"
                          />
                          {media.type === 'video' && (
                            <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                              <Play className="w-6 h-6 text-white fill-white" />
                            </div>
                          )}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </details>
            )}

            {/* Description */}
            <div className="project-detail__panel bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-3">Description</h3>
              <p className="text-gray-700 leading-relaxed">{lead.job_description}</p>
            </div>

            {/* Assignment Status */}
            <div className="project-detail__panel project-detail__assignment bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4">Your contractor</h3>

              {lead.job_status === 'OPEN' && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-center">
                    <Building2 className="w-5 h-5 mr-2 text-blue-600" />
                    <span className="text-blue-800 font-medium">
                      This project is open and available for any contractor to accept
                    </span>
                  </div>
                </div>
              )}

              {/* Accepted Contractor */}
              {lead.accepted_contractor && (
                <div className="mb-4">
                  <h4 className="text-sm font-medium text-gray-700 mb-3">Accepted Contractor</h4>
                  <ContractorCard
                    contractor={{
                      ...lead.accepted_contractor,
                      sent_at: undefined,
                    }}
                    onMessage={(contractor:any) =>{
                      setChat(true)
                      console.log("hi")

                      setSelectedContractor({ id: contractor.id, name: contractor.user_first_name })
                    }}
                    type="accepted"
                  />
                </div>
              )}

              {/* Requested Contractors List */}
              {lead.requested_contractors_list && lead.requested_contractors_list.length > 0 && (
                <div>
                  <h4 className="text-sm font-medium text-gray-700 mb-3">
                    Requested Contractors ({lead.requested_contractors_list.length})
                  </h4>
                  <div className="space-y-3">
                    {lead.requested_contractors_list.map((contractor:any) => (
                      <ContractorCard
                        key={contractor.id}
                        contractor={{
                          ...contractor,
                          accepted_at: undefined,
                        }}
                        onMessage={(contractor:any) =>{
                          setChat(true)
                          console.log("hi")
    
                          setSelectedContractor({ id: contractor.id, name: contractor.user_first_name })
                        }}
                        type="requested"
                      />
                    ))}
                  </div>
                </div>
              )}

              {lead.job_status === 'REQUESTED' && !lead.requested_contractors_list?.length && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-center mb-2">
                    <Building2 className="w-5 h-5 mr-2 text-blue-600" />
                    <span className="text-blue-800 font-medium">
                      Sent to {lead.requested_contractors} specific {lead.requested_contractors === 1 ? 'contractor' : 'contractors'}
                    </span>
                  </div>
                  <div className="text-sm text-blue-700">
                      Waiting for a contractor to accept from the requested list
                  </div>
                </div>
              )}
            </div>

            {lead.accepted_contractor && (
              <div className="project-detail__panel project-detail__contract-state bg-white border border-gray-200 rounded-lg p-6">
                <div className="project-detail__contract-state-heading">
                  <div>
                    <h3>Contract status</h3>
                    <p>{isLiveContract ? 'Your contract is active and ready for project updates.' : linkedContract ? 'Your contractor is preparing the agreement.' : 'Your contractor will prepare the agreement next.'}</p>
                  </div>
                  <span className={`project-detail__contract-state-badge project-detail__contract-state-badge--${isLiveContract ? 'live' : 'pending'}`}>
                    {isLiveContract ? 'Live' : 'In progress'}
                  </span>
                </div>
                {linkedContract && (
                  <button type="button" className="project-detail__contract-action" onClick={() => navigate(`/create-contract?tab=Project-Details&id=${linkedContract.id}`)}>
                    <FileText size={16} aria-hidden="true" />
                    {isLiveContract ? 'View live contract' : 'View contract progress'}
                    <ArrowRight size={16} aria-hidden="true" />
                  </button>
                )}
                {isLiveContract && linkedContract?.id && <div className="project-detail__contract-review"><InlineContractReview projectId={linkedContract.id} /></div>}
              </div>
            )}

            {/* History */}
            <div className="project-detail__panel project-detail__history bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4">History</h3>
              <div className="space-y-4">
                {lead.history.map((entry:any) => (
                  <div key={entry.id} className="project-detail__history-item flex gap-4 pl-5 pb-4 last:pb-0">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-2 h-2 bg-blue-600 rounded-full -ml-[25px]"></div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-start justify-between mb-1">
                        <div className="font-medium">{ toProperCase(entry.action.replace("_"," ")) }</div>
                        <div className="flex items-center text-xs text-gray-500">
                          <Clock className="w-3 h-3 mr-1" />
                          {new Date(entry.timestamp).toLocaleString()}
                        </div>
                      </div>
                      <div className="text-sm text-gray-600">{entry.details}</div>
                      <div className="text-xs text-gray-500 mt-1">by {entry.user}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Quick Info */}
            <div className="project-detail__panel project-detail__info bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4">Details</h3>
              <div className="space-y-4">
                <div>
                  <div className="text-sm text-gray-600 mb-1">Created</div>
                  <div className="flex items-center">
                    <Calendar className="w-4 h-4 mr-2 text-gray-400" />
                    <span className="font-medium">{new Date(lead.created_at).toLocaleDateString()}</span>
                  </div>
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">Budget</div>
                  <div className="flex items-center">
                    <DollarSign className="w-4 h-4 mr-2 text-gray-400" />
                    <span className="text-2xl font-semibold">${lead.job_budget.toLocaleString()}</span>
                  </div>
                  {lead.escrow_enabled && (
                    <div className="flex items-center mt-2 px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full w-fit">
                      <Shield className="w-4 h-4 mr-1.5" />
                      Escrow Enabled
                    </div>
                  )}
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">Location</div>
                  <div className="flex items-start">
                    <MapPin className="w-4 h-4 mr-2 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-medium">{lead.address}</div>
                      <div className="text-gray-600 text-sm">{lead.city}, {lead.state} {lead.zip_code}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Media Count */}
            {allMedia.length > 0 && (
              <div className="project-detail__panel bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="font-semibold text-lg mb-4">Media</h3>
                <div className="space-y-2">
                  {images.length > 0 && (
                    <div className="flex items-center justify-between">
                      <div className="flex items-center text-gray-700">
                        <ImageIcon className="w-4 h-4 mr-2" />
                        <span>Images</span>
                      </div>
                      <span className="font-medium">{images.length}</span>
                    </div>
                  )}
                  {videos.length > 0 && (
                    <div className="flex items-center justify-between">
                      <div className="flex items-center text-gray-700">
                        <Video className="w-4 h-4 mr-2" />
                        <span>Videos</span>
                      </div>
                      <span className="font-medium">{videos.length}</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Actions */}
            <div className="project-detail__panel project-detail__danger-zone bg-white border border-gray-200 rounded-lg p-6">
              {!hasAcceptedContractor && !linkedContract ? <button onClick={() => {
        setAlertDetails({
          status: true,
          title: "Delete Project",
          message: "Are you sure you want to delete this project? It will no longer be visible to contractors.",
          icon: Trash,
          button1Text: "Cancel",
          button2Text: "Yes, delete project",
          button1Style:
            "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200",
          button2Style:
            "px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700",
          onButton1Click: () => {},
          onButton2Click: () => {
            setLoading(true)
            CallAPIPostPromise("/jobs/deleteJob",{
              jobId:lead.id,
              homeownerId:getDecodeId()
            }).then(()=>{
              navigate('/pages-projects')
            }).catch(()=>{
              
            }).finally(()=>{
              setLoading(false)
            })
          },
        });
      }} className="project-detail__delete w-full px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                Delete Project
              </button> : <div className="project-detail__protected-action">
                <Send size={16} aria-hidden="true" />
                <div><strong>Project is in progress</strong><span>To protect the contractor agreement and activity history, this project can no longer be deleted.</span></div>
              </div>}
            </div>
          </div>
        </div>
      </div>

      {/* Message Modal */}
      {selectedContractor && <LeadMessageModal
        peerId={selectedContractor.id}
        name={selectedContractor.name}
        leadTitle={lead.job_title}
        peerLabel="Contractor"
        show={chat}
        onClose={() => setChat(false)}
      />}
      <TwoButtonAlert setDetails={setAlertDetails} details={alertDetails} />

      </Container>
     
    </div>
  );
}
